import { AiReportColumnMapping } from '../../models/AiReportHelper';

export function describeFill(rule: AiReportColumnMapping[string] | undefined): string | null {
    if (!rule?.customFill) return null;
    const fill = rule.customFill;
    if (fill.mode === 'constant') return `Always fill with "${fill.value}"`;
    if (fill.mode === 'lookup') return `Looked up from "${fill.lookupSourceColumn}"`;
    if (fill.mode === 'customerProfile') {
        const matchLabel = fill.matchProfileField === 'customer_name' ? 'name' : 'code';
        return `From customer profile: ${fill.profileField} (matched by ${matchLabel})`;
    }
    if (fill.mode === 'dropdown') return `Always fill with "${fill.value}" (from a dropdown)`;
    if (fill.mode === 'checkbox') return `Always fill with "${fill.value}" (checkbox)`;
    if (fill.mode === 'dataset') return `From data set "${fill.datasetName}": ${fill.datasetColumnLabel} (matched by "${fill.matchSourceColumn}")`;
    return null;
}
